import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class ClustersApi extends ApiModule {
	constructor() {
		super(ModulesMap.CLUSTERS, {
			entity: 'clusters',
		})
	}
}
